import { ContentContainer } from "components/ui/display/ContentContainer";
import styled, { useTheme } from "styled-components";
import dragHandleUrl from 'assets/icons/drag_handle_300.svg';

import { Tag } from "components/ui/display/Tag";
import { useDraggable } from "@dnd-kit/react";
import { useNavigate } from "react-router-dom";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";

export const ProjectsKanbanCard = ({project}) => {

    const navigate = useNavigate();

    const { ref, handleRef } = useDraggable({id: project.projectUuid});
    let latestUpdate = null;

    

    if(project.projectPhases.enabled)
    {
        latestUpdate = project.projectPhases.paths
                        .flatMap(path => path.pathUpdates)
                        .reduce((latest, current) => {
                            if(!latest) return current;
                            return new Date(current.date) > new Date(latest.date) ? current : latest;
                        }, null);
    }

    return (
        <StyledProjectsKanbanCard
            ref={ref}
            contentOrientation="row"
            contentGap='md'
            dropShadow="sm"
            onDoubleClick={() => navigate("/projects/" + project.projectUuid)}
        >
            <div className="cardAside" ref={handleRef}>
            </div>
            <div className="cardContent">
                <div className="cardMainInfo">
                    <div className="cardTagsContainer">
                        <Tag text={project.projectNumber}/>
                        {project.projectPhases.enabled && project.projectPhases.mainPhase ? <Tag text={project.projectPhases.mainPhase}/> : null}
                    </div>
                    <div className="cardProjectName">
                        {project.projectName}
                    </div>
                    {
                        project.projectContent.enabled ?
                            <div className="cardProjectContent">
                                {project.projectContent.road ? <Tag icon={<MaterialIcon name='road' weight={400}/>}/> : null}
                                {project.projectContent.sign ? <Tag icon={<MaterialIcon name='directions' weight={400}/>}/> : null}
                                {project.projectContent.signal ? <Tag icon={<MaterialIcon name='traffic' weight={400}/>}/> : null}
                                {project.projectContent.traffic ? <Tag icon={<MaterialIcon name='traffic_jam' weight={400}/>}/> : null}
                                {project.projectContent.safety ? <Tag icon={<MaterialIcon name='outdoor_garden' weight={400}/>}/> : null}
                                {project.projectContent.bim ? <Tag icon={<MaterialIcon name='brick' weight={400}/>}/> : null}
                                {project.projectContent.models3d ? <Tag icon={<MaterialIcon name='3d' weight={400}/>}/> : null}
                                {project.projectContent.document ? <Tag icon={<MaterialIcon name='draft' weight={400}/>}/> : null}
                            </div>
                            : null
                    }
                </div>
                {
                    latestUpdate ?
                        <div className="cardFooter">
                        <MaterialIcon
                            name='tooltip'
                            weight={300}
                            size='sm'
                        />
                        <div>
                            {latestUpdate ? latestUpdate.description : null}
                        </div>
                    </div>
                    : null
                }
                
            </div>
        </StyledProjectsKanbanCard>
    )
}

const StyledProjectsKanbanCard = styled(ContentContainer)`

    div.cardAside
    {
        flex: 0 0 15px;
        background-image: url(${dragHandleUrl});
        background-size: 110% auto;
        background-position: top center;
        width: 15px;
        cursor: grab;
        transition-duration: 110ms;
        
        
        opacity: 0.25;

        &:hover
        {
            opacity: 0.5;
        }
    }

    div.cardContent
    {
        user-select: none;
        cursor: pointer;
        flex: 1 1 auto;
        display: flex;
        flex-direction: column;
        gap: ${({theme}) => theme.spacing.md};

        div.cardMainInfo
        {
            flex: 1 1 auto;
            display: flex;
            flex-direction: column;
            gap: ${({theme}) => theme.spacing.md};

            div.cardTagsContainer
            {
                display: flex;
                gap: ${({theme}) => theme.spacing.sm};
            }

            div.cardProjectName
            {
                font-weight: 600;
            }

            div.cardProjectContent
            {
                display: flex;
                gap: ${({theme}) => theme.spacing.sm};
            }
        }
        
        div.cardFooter
        {
            border-top: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
            padding-top: ${({theme}) => theme.spacing.md};
            
            display: flex;
            align-items: flex-start;
            gap: ${({theme}) => theme.spacing.md};
            color: ${({theme}) => theme.colors.mutedForeground};
            
            svg
            {
                width: 18px;
                height: 18px;
                color: ${({theme}) => theme.colors.mutedForeground};
            }

            div
            {
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                overflow: hidden;
            }
        }
    }


`

export const ProjectsEmptyKanbanCard = () => {

    const GlobalTheme = useTheme();
    const color = encodeURIComponent(GlobalTheme.colors.mutedForeground);

    const backgroundBorderUrl = `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='6' ry='6' stroke='${color}' stroke-width='2' stroke-dasharray='10%2c 8' stroke-dashoffset='5' stroke-linecap='square'/%3e%3c/svg%3e")`
    

    return (
        <StyledProjectsEmptyKanbanCard $borderImageUrl = {backgroundBorderUrl}>
            Dra prosjektet over her.
        </StyledProjectsEmptyKanbanCard>
    )
}

const StyledProjectsEmptyKanbanCard = styled.div`
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({theme}) => theme.colors.mutedForeground};
    border-radius: ${({theme}) => theme.cornerRadius.md};
    background-image: ${({$borderImageUrl}) => $borderImageUrl};
    user-select: none;
    text-align: center;
    padding: ${({theme}) => theme.spacing.md};
`
    